module.exports = __webpack_public_path__ + "img/home-clothing8.782d00b8.png";